<template lang="pug">
div.data-badge
	.data-badge__body
		a.data-badge__heading(
			:href="link"
		) {{ heading }} 
			span.mdi.mdi-arrow-right

		.data-badge__stats
			div.data-badge__stat.data-badge__stat-value
				.data-badge__value
					span.data-badge__value-number {{ valueWithoutUnit }}
					span.data-badge__value-unit {{ unitOfValue }}
				.data-badge__stat-label {{  valueLabel }}
			div.data-badge__stat-line
			div.data-badge__stat.data-badge__stat-change
				.data-badge__change
					.data-badge__change-arrow(
						:class="changeArrowClass"
					)
						.fa(
							:class="{'fa-chevron-down': !positiveChange, 'fa-chevron-up': positiveChange}"
						)
					.data-badge__change-value
						span.data-badge__change-number {{ percentChange.replace(/%$/,'') }}
						span.data-badge__change-unit %
				.data-badge__stat-label {{ percentLabel }}

		hr.data-badge__hr

		.data-badge__description(
			v-html="description"
		)

	.data-badge__footer(
		:class="{['data-badge__footer--'+color]: true}"
	)
		.data-badge__footer-time {{  timePeriod }}

</template>

<script>
const formatter = Intl.NumberFormat("en", { notation: "compact" });
export default {
	props: {
		data: Object,
		heading: String,
		link: String,
		value: String,
		valueSuffix: String,
		valueLabel: String,
		valueFormat: {
			type: String,
			default: '1.1a'
		},
		percentChange: String,
		percentLabel: String,
		description: String,
		footerType: {
			type: String,
			default: 'time-period'
		},
		timePeriod: String,
		footerButtons: Array,
		color: String
	},

	data() {
		let formattedValue = this.value;
		switch( this.valueFormat ){
			case '1.1a':
				formattedValue = formatter.format( Number(this.value.replace(/[,]/gi,'')) );
				break;
				
			case '%':
				break;

			default:
				formattedValue = String(Math.round(this.value));
		}
		return {
			formattedValue
		}
	},

	computed: {
		valueWithoutUnit(){
			return this.formattedValue.replace(/[^0-9.,]/ig,'')
		},
		unitOfValue(){
			return this.formattedValue.replace(/[0-9.,]/ig,'')
		},
		changeArrowClass(){
			let negative = Number(this.percentChange.replace('%','') ) < 0;
			return {
				'data-badge__change-arrow--red' : negative,
				'data-badge__change-arrow--green' : !negative,
			};
		},
		positiveChange(){
			let positive = Number(this.percentChange.replace('%','') ) > 0;
			return positive;
		}
	}
}
</script>
<style lang="scss" scoped>
@import 'resources/assets/scss/front/variables';
@import 'resources/assets/scss/front/bootstrap-overrides';
@import "~bootstrap/scss/_functions";
@import "~bootstrap/scss/_variables";
@import "~bootstrap/scss/_mixins";

.data-badge {
	background: #fff;
	border-radius: 0.75rem;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	&__body {
		padding: 1em;
		display: flex;
		flex-direction: column;
		align-items: center;;
		gap: 1em;
		flex-grow: 1;
	}

	&__heading {
		font-weight: 700;
	}

	&__stats { 
		display: flex;
		gap: 1em;
	}
	&__stat-line {
		width: 1px;
		background: $color-gray-2;
	}
	&__stat {
		display: flex;
		flex-direction: column;
		justify-content: end;
		gap: 0.25em;
		align-items: center;
	}
	&__stat-label {
		font-size: 0.85em;
		color: $color-gray-4;
	}

	&__value {
		color: #000;
		line-height: 1;
	}

	&__value-number {
		font-size: 3em;
		font-weight: 800;
		line-height: 1;
	}
	&__value-unit {
		font-size: 1.875em;
	}

	&__change-arrow {
		font-size: 1.33em;
		&--red {
			color: #E25B20;
		}
		&--green {
			color: #97CA3B;
		}
	}

	&__change {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: rgb(158,158,158);
		line-height: 1;
	}

	&__change-number {
		font-size: 2em;
		line-height: 1.1;
	}

	&__hr {
		margin-top: 0;
		margin-bottom: 0;
		height: 1px;
		width: 100%;
		border-top: 0;
		background: $color-gray-2;
	}

	&__description {
		text-align: center;
		font-size:0.85em;
	}

	&__footer {
		padding: 0.75em 0.5em;
		display: flex;
		justify-content: center;
		background: $color-warm-gray-8;
		color: #fff;
		text-transform: uppercase;
		font-weight: 800;
		&--blue {
			background: $color-medium-blue;
		}
		&--orange {
			background: $color-orange;
		}
		&--green {
			background: $color-dark-green;
		}
	}
}
</style>